import clsx from 'clsx'
import React, { FC, useContext } from 'react'

import Container from '@Components/CMS/Container'
import { Page, PageGrid } from '@Components/CMS/PageGrid'
import { Link } from '@Components/Link'
import { MetadataContext } from '@Globals/Metadata'

import styles from './CardList.module.scss'

interface ListProps {
  data: Page[]
  label: string
  mobileLimit?: number
  title: string
  url: string
}
// TODO possible to optimize further by removing CardListContainer
export const CardList: FC<ListProps> = ({
  data,
  label,
  mobileLimit,
  title,
  url,
}) => {
  const { storeURL } = useContext(MetadataContext)

  if (!data) {
    return null
  }

  return (
    <section className={styles.cardListRoot}>
      <h3 className={styles.cartListTitle}>{title}</h3>
      <Container className={clsx(styles.cardListContainer, mobileLimit && styles.mobileLimit)} width="wide">
        <PageGrid
          columns={3}
          items={data}
          showDescription
          titlePosition="bottom"
        />
        <div className={styles.cardListLinkContainer}>
          <Link className={styles.cardListLink} href={storeURL(url)}>{label}</Link>
        </div>
      </Container>
    </section>
  )
}

